 const CaretDown = ({color})=>(
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Icon/CaretDown">
<path id="Vector" d="M12.9989 6L7.9989 11L2.9989 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</g>
</svg>)

export  {CaretDown};